import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-help-menu',
  imports: [TranslateModule],
  templateUrl: './help-menu.html',
  styleUrl: './help-menu.css'
})
export class HelpMenu {

}
